var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('car-introduction'),_c('car-service',{attrs:{"id":"service"}}),_c('phone',{staticClass:"phone"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }